export default function payHeader (){
    return {
      'Content-Type': 'application/json', 
      'Accept': 'application/json'
    }
  }